// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__Oszsi","header":"Messages_header__1pX-F"};